/**
 * Lightweight dataLayer shim. Any downstream analytics consumer (GTM,
 * PostHog custom capture, server-side beacon) can subscribe to
 * window.dataLayer without us needing to know about it here.
 *
 * Usage:
 *   track('buy_click',    { location: 'hero' });
 *   track('contact_click', { method: 'call' });
 *   track('lead_submit',   { source: 'barge' });
 */
export function track(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

export default track;
